export var INVITATION_DATE = "created_at";
export var A_Z = "lastname";
export var SORT_OPTIONS = [
    { label: "admin.constants.sort.AZ.label", value: A_Z },
    { label: "admin.constants.sort.invitationDate.label", value: INVITATION_DATE }
];
